import FileSaver from "file-saver";
import {config} from "../../../config";
import Invoice from "../model/invoice.model";

export function downloadInvoice(invoice: Invoice): void {
  fetch(config.baseUrl + `/invoice/${invoice.id}/download`)
    .then((response: Response): void => {
      // Error handing to be added in a later ticket. For now, the user doesn't get any feedback that the invoice
      // could not be found. The request does get a 500 error which will show up in the JavaScript console.
      // @see https://trined.atlassian.net/browse/TRIK-2947
      if (!response.ok) {
        return;
      }

      response.blob()
        .then((blob: Blob) => {
          FileSaver.saveAs(blob, `${invoice.invoice_number}.pdf`);
        });
    });
}
